import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IUpdateVenueOpeningTimeRequestBody } from './types';

export const updateVenueOpeningTime = (
  venueId: string,
  venueOpeningTimeId: string,
  openingTime: IUpdateVenueOpeningTimeRequestBody,
): Promise<any> => {
  return fetch(`${API_URL}/venues/${venueId}/schedules/${venueOpeningTimeId}`, {
    method: 'PATCH',
    body: JSON.stringify(openingTime),
    headers: {
      'content-type': 'application/json',
    },
  });
};
